module.exports = __webpack_public_path__ + "static/img/9.cf8e320.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/sp/9.png
// module id = e0bq
// module chunks = 0